<template>
  <v-dialog
    v-model="dialog"
    max-width="70vw"
    scrollable
    :retain-focus="false"
    persistent
  >
    <v-card>
      <v-toolbar
          color="primary"
          dark
        >Add Service Code</v-toolbar>
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="item.ServiceCode"
                clearable
                flat
                label="Service Code"
                :rules="requiredRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="item.ServiceTitle"
                clearable
                flat
                label="Service Title"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="4">
              <v-autocomplete
                v-model="item.Units"
                label="Unit of Service"
                outlined
                :items="units"
                :rules="requiredRules"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="4">
            <v-text-field
                v-model="item.AnnualUnits"
                label="Annual Units"
                :rules="requiredRules"
            ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4">
            <v-text-field
                v-model="item.Rate"
                label="Rate"
                prefix="$"
                :rules="requiredRules"
                type="number"
            ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="item.StartDate"
                    label="Start Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.StartDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="item.EndDate"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.EndDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu2 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12">
                <v-switch v-model="item.Active" :label="item.Active ? 'Active' : 'Deactive'"></v-switch>
            </v-col>
        </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" color="#259647" @click="onAddItem()">Save</v-btn>
        <v-btn
          color="primary"
          text
          @click="close"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable */
export default {
  data() {
    return {
      gender: ["Male", "Female"],
      newItem: true,
      units: ["Daily", "Hourly", "Quarter Hour", "Monthly", "Session"],
      item: {
        ServiceCode: "",
        ServiceTitle: "",
        AnnualUnits: "",
        Units: "",
        Rate: "",
        StartDate: "",
        EndDate: "",
        Active: "Active",
      },
      defaultItem: {
        ServiceCode: "",
        ServiceTitle: "",
        AnnualUnits: "",
        Units: "",
        Rate: "",
        StartDate: "",
        EndDate: "",
        Active: "Active",
      },
      requiredRules: [
            v => !!v || 'This is required',
        ],
      timeStartPicker: false,
      timeStart: null,
      timeEndPicker: false,
      timeEnd: null,
      requiredTime: false,
      menu: false,
      menu2: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.attendance.dialog;
      },
      set(val) {
        this.$store.commit("attendance/SET_DIALOG", val);
      },
    },
      clientId: {
          get() {
              return this.$store.state.attendance.clientId;
          },
          set(val) {
              this.$store.commit("attendance/SET_CLIENT_ID", val);
          },
      },
  },

  created(){
    // this.clientId = (  this.clientID === null ?  this.$route.params.clientID :  localStorage.getItem("clientId") );a
  },
  methods: {
    async onAddItem() {
      let hasEmptyField = false;
      if (this.item.ServiceCode === '') hasEmptyField = true;
      if (this.item.Units === '' && !hasEmptyField) hasEmptyField = true;
      if (this.item.AnnualUnits === '' && !hasEmptyField) hasEmptyField = true;
      if (this.item.Rate === '' && !hasEmptyField) hasEmptyField = true;
      if ((this.item.Active !== 'Active' && this.item.Active !== 'Deactive') && !hasEmptyField) hasEmptyField = true;


        if (hasEmptyField) {
        this.$store.commit(
          "SET_SNACKBAR",
          {
            show: true,
            text: "Please fill the required fields. ",
            color: "red accent-4",
          },
          null,
          { root: false }
        );

        this.$store.commit("attendance/SET_ADD_ATTENDANCE_DIALOG", true);

        return false;
      }

      try {
        const response = await this.$store.dispatch("attendance/addServiceCode", {
          ...this.item,
          ClientID: this.clientId,
        });

        if (response) {
          this.close();
            this.$emit('update-codes', response);
          await this.$store.dispatch("attendance/addCode", {
            ...this.item,
          });
          this.$store.commit("attendance/SET_ADD_ATTENDANCE_DIALOG", false);
          this.$store.commit("attendance/SET_ADD_ATTENDANCE_DIALOG", true);
        }
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.item = Object.assign({}, this.defaultItem);
      });
    },
  },
};
</script>
